<template>
  <div>
    <v-switch
      :label="params.toggleLabel"
      :input-value="params.toggleValue"
      :true-value="params.trueValue"
      :false-value="params.falseValue"
      primary
      hide-details
      class="pt-3 pb-2 font-weight-regular"
      @change="toggle"
    />
    <v-row align="center" dense no-gutters>
      <div class="pb-2">{{ params.headerLine1 }}</div>
      <div v-if="params.displayCompetitorsSelection">
        <competitors-selector />
      </div>
    </v-row>
    <div v-if="params.headerLine2" class="header-line2">{{ params.headerLine2 }}</div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    toggle(value) {
      this.params.onToggle(value);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.header-line2 {
  padding-bottom: 8px;
  font-weight: normal;
  color: $text-color-muted;
}
</style>
